'use client';

import { c as _c } from "react/compiler-runtime";
import { useNebulyPageContext } from '@/domains/pages/context/nebuly-page-context';
import { useLayoutEffect } from 'react';

/** Overrides the shell title subject (e.g. humanized segment name) while the page body is mounted. */
export function useNebulyPageTitleSubject(subject) {
  const $ = _c(4);
  const {
    setTitleSubject
  } = useNebulyPageContext();
  let t0;
  let t1;
  if ($[0] !== setTitleSubject || $[1] !== subject) {
    t0 = () => {
      setTitleSubject(subject);
      return () => setTitleSubject(undefined);
    };
    t1 = [setTitleSubject, subject];
    $[0] = setTitleSubject;
    $[1] = subject;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
}